import formatString from 'string-format'

export const getTogetherPath = (
  path: string,
  params?: { [key: string]: string | number },
  version?: string,
) => {
  return (
    process.env.NEXT_PUBLIC_TOGETHER_API +
    `api/${version || 'v1'}/` +
    formatString(path, { websiteUrl: 'https://marrybaby.vn', ...params })
  )
}
